import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import brand from "../../../config/brand";
import NavigationHeader from "../../Common/NavigationHeader/NavigationHeader";
import LiveWinsSection from "../../Common/WinnerCard/LiveWinsSection";
import { StyledPageContainer } from "./styles";
import TvSlots from "./TvSlots";
import TvMines from "./TvMines";
import TvCrash from "./TvCrash";

const ORIGINALS = [
  {
    id: "tv-gold-reels",
    title: "Gold Reels",
    provider: brand.originalsLabel,
    initials: "GR",
    accent: "#FFD700",
    bg: "linear-gradient(145deg, rgba(255, 215, 0, 0.26), rgba(111, 75, 0, 0.18))",
  },
  {
    id: "tv-mines",
    title: "Mines",
    provider: brand.originalsLabel,
    initials: "MI",
    accent: "#60A5FA",
    bg: "linear-gradient(145deg, rgba(96, 165, 250, 0.22), rgba(15, 23, 42, 0.42))",
  },
  {
    id: "tv-crash",
    title: "Crash",
    provider: brand.originalsLabel,
    initials: "CR",
    accent: "#F97316",
    bg: "linear-gradient(145deg, rgba(249, 115, 22, 0.24), rgba(49, 46, 129, 0.28))",
  },
];

const GAME_COMPONENTS = {
  "tv-gold-reels": TvSlots,
  "tv-mines": TvMines,
  "tv-crash": TvCrash,
};

const PLAY_MODES = ["demo", "account"];

const AKOriginals = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeGame, setActiveGame] = useState(null);
  const gameParam = searchParams.get("game");
  const playModeParam = searchParams.get("playMode");

  useEffect(() => {
    if (gameParam) {
      if (GAME_COMPONENTS[gameParam]) {
        setActiveGame({
          id: gameParam,
          playMode: PLAY_MODES.includes(playModeParam) ? playModeParam : "demo",
        });
      } else {
        setActiveGame(null);
      }
      return;
    }

    setActiveGame(null);
  }, [gameParam, playModeParam]);

  const openGame = (id, playMode) => {
    setSearchParams({ game: id, playMode });
  };

  const closeGame = () => {
    setSearchParams({});
    setActiveGame(null);
  };

  if (activeGame) {
    const GameComponent = GAME_COMPONENTS[activeGame.id];
    return (
      <StyledPageContainer>
        <div className="p-4">
          <button
            onClick={closeGame}
            className="mb-4 text-yellow-400 hover:text-yellow-300 flex items-center gap-2 text-sm"
          >
            Back to {brand.originalsLabel}
          </button>
          <GameComponent playMode={activeGame.playMode} />
        </div>
      </StyledPageContainer>
    );
  }

  return (
    <StyledPageContainer>
      <LiveWinsSection title="Live wins" hasFilters={true} />
      <NavigationHeader isNftPage={false} />
      <div className="content-container">
        <div
          style={{
            display: "grid",
            width: "100%",
            gridTemplateColumns: "repeat(auto-fill, minmax(105px, 1fr))",
            gap: "12px 6px",
          }}
          className="originals-grid"
        >
          {ORIGINALS.map((game) => (
            <div key={game.id}>
              <div
                className="overflow-hidden border border-yellow-500/20 hover:border-yellow-400 transition-all"
                style={{
                  aspectRatio: "3/4",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderRadius: "8px",
                  background: game.bg,
                }}
              >
                <div
                  style={{
                    alignSelf: "center",
                    width: "48px",
                    height: "48px",
                    borderRadius: "8px",
                    border: `1px solid ${game.accent}`,
                    color: game.accent,
                    display: "grid",
                    placeItems: "center",
                    fontWeight: 900,
                    fontSize: "16px",
                    background: "rgba(15, 17, 26, 0.55)",
                  }}
                >
                  {game.initials}
                </div>
                <div>
                  <div
                    style={{
                      color: "#FFD700",
                      fontWeight: "700",
                      fontSize: "12px",
                      textAlign: "center",
                      lineHeight: 1.2,
                    }}
                  >
                    {game.title}
                  </div>
                  <div
                    style={{
                      color: "#9ca3af",
                      fontSize: "9px",
                      marginTop: "3px",
                      textAlign: "center",
                    }}
                  >
                    {game.provider}
                  </div>
                </div>
                <div className="originals-actions">
                  <button type="button" onClick={() => openGame(game.id, "demo")}>
                    Free Play
                  </button>
                  <button
                    type="button"
                    className="account-play"
                    onClick={() => openGame(game.id, "account")}
                  >
                    Play
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (min-width: 600px) {
          .originals-grid {
            grid-template-columns: repeat(auto-fill, minmax(135px, 1fr)) !important;
            gap: 18px 12px !important;
          }
        }

        .originals-actions {
          display: grid;
          gap: 6px;
        }

        .originals-actions button {
          width: 100%;
          min-height: 28px;
          border-radius: 6px;
          border: 1px solid rgba(255, 215, 0, 0.28);
          background: rgba(15, 17, 26, 0.7);
          color: #FFD700;
          font-size: 11px;
          font-weight: 700;
          line-height: 1;
          cursor: pointer;
        }

        .originals-actions .account-play {
          background: #FFD700;
          color: #10121B;
        }
      `}</style>
    </StyledPageContainer>
  );
};

export default AKOriginals;
